import { render, staticRenderFns } from "./cardBuddy.vue?vue&type=template&id=71d1b1bc&"
import script from "./cardBuddy.vue?vue&type=script&lang=js&"
export * from "./cardBuddy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports